/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';
import type { Session } from './Session';
import {
    SessionFromJSON,
    SessionFromJSONTyped,
    SessionToJSON,
} from './Session';

/**
 * 
 * @export
 * @interface ListSession200Response
 */
export interface ListSession200Response {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListSession200Response
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<Session>}
     * @memberof ListSession200Response
     */
    objects: Array<Session>;
}

/**
 * Check if a given object implements the ListSession200Response interface.
 */
export function instanceOfListSession200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "objects" in value;

    return isInstance;
}

export function ListSession200ResponseFromJSON(json: any): ListSession200Response {
    return ListSession200ResponseFromJSONTyped(json, false);
}

export function ListSession200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSession200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'objects': ((json['objects'] as Array<any>).map(SessionFromJSON)),
    };
}

export function ListSession200ResponseToJSON(value?: ListSession200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'objects': ((value.objects as Array<any>).map(SessionToJSON)),
    };
}

